/**
 * Created by dmy on 05.04.2017.
 */
export enum Role {
  user,
  admin
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/models/Role.enum.ts